import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../hooks/useAuth'

export function ProtectedRoute({ children }) {
  const { isAuthenticated, onboardingComplete, loading, profile } = useAuth()
  const location = useLocation()

  // Treat "authenticated but profile not yet loaded" as a loading state.
  // Without this, there's a window between SIGNED_IN firing (setUser=true)
  // and the profile fetch resolving (setProfile=row) where the route would
  // see isAuthenticated=true, profile=null, and conclude onboarding wasn't
  // complete — bouncing the user through /onboarding for one render before
  // the profile arrived and ricocheting them back to /dashboard.
  const profileLoading = isAuthenticated && !profile

  if (loading || profileLoading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex',
        alignItems: 'center', justifyContent: 'center',
        background: '#0a0c10',
      }}>
        <div style={{
          width: 28, height: 28,
          border: '2px solid rgba(255,255,255,0.1)',
          borderTopColor: '#e8ff47', borderRadius: '50%',
          animation: 'spin 0.6s linear infinite',
        }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // If onboarding is complete and user tries to visit /onboarding — send to dashboard
  if (onboardingComplete && location.pathname === '/onboarding') {
    return <Navigate to="/dashboard" replace />
  }

  // If onboarding not complete and not already on onboarding — redirect there
  const exempt = ['/onboarding', '/choose-your-path']
  if (!onboardingComplete && !exempt.includes(location.pathname)) {
    return <Navigate to="/onboarding" replace />
  }

  return children
}
